import { createConsumer } from '@rails/actioncable';
import { onBeforeUnmount } from 'vue';

const createSharedConsumer = () => {
  const { websocketURL = '' } = window.chatwootConfig || {};
  const cableURL = websocketURL ? `${websocketURL}/cable` : undefined;
  return createConsumer(cableURL);
};

const consumer = createSharedConsumer();

const useScheduledMessagesChannel = () => {
  const subscriptions = new Map();

  const subscribeToScheduledMessages = (conversationId, handler) => {
    if (!conversationId || subscriptions.has(conversationId)) return;

    const subscription = consumer.subscriptions.create(
      {
        channel: 'ScheduledMessagesChannel',
        conversation_id: conversationId,
      },
      {
        received: data => {
          handler?.(data);
        },
      }
    );

    subscriptions.set(conversationId, subscription);
  };

  const unsubscribeFromScheduledMessages = conversationId => {
    if (!subscriptions.has(conversationId)) return;
    const subscription = subscriptions.get(conversationId);
    consumer.subscriptions.remove(subscription);
    subscriptions.delete(conversationId);
  };

  const resetSubscriptions = () => {
    subscriptions.forEach(subscription => {
      consumer.subscriptions.remove(subscription);
    });
    subscriptions.clear();
  };

  onBeforeUnmount(() => {
    resetSubscriptions();
  });

  return {
    subscribeToScheduledMessages,
    unsubscribeFromScheduledMessages,
    resetSubscriptions,
  };
};

export default useScheduledMessagesChannel;
